import { isZodArray, isZodDefault, isZodEffects, isZodIntersection, isZodNullable, isZodObject, isZodOptional, isZodPrimitives, isZodPromise, isZodReadonly, isZodUnion } from ".";
export const getKeysFromZodSchema = (model, isSelectKey, parentKey) => {
    if (isZodObject(model)) {
        const objKeys = {};
        Object.entries(model.shape).map(([key, schema]) => {
            objKeys[key] = getKeysFromZodSchema(schema, isSelectKey, parentKey ? `${parentKey}.${key}` : key);
        });
        return objKeys;
    }
    else if (isZodUnion(model)) {
        const result = model.options.reduce((prev, curr) => {
            const result = getKeysFromZodSchema(curr, isSelectKey, parentKey);
            return {
                ...(typeof prev === "object" ? prev : {}),
                ...(typeof result === "object" ? result : {}),
            };
        }, {});
        if (Object.keys(result).length > 0) {
            return result;
        }
    }
    else if (isZodIntersection(model)) {
        const left = getKeysFromZodSchema(model._def.left, isSelectKey, parentKey);
        const right = getKeysFromZodSchema(model._def.right, isSelectKey, parentKey);
        return {
            ...(typeof left === "object" ? left : {}),
            ...(typeof right === "object" ? right : {}),
        };
    }
    else if (isZodArray(model)) {
        const arrayElement = model.element;
        if (!isSelectKey && !isZodPrimitives(arrayElement)) {
            const arrayKey = (index) => getKeysFromZodSchema(arrayElement, isSelectKey, `${parentKey}.${index}`);
            arrayKey.key = parentKey;
            return arrayKey;
        }
        return getKeysFromZodSchema(arrayElement, isSelectKey, parentKey);
    }
    else if (isZodOptional(model) || isZodNullable(model) || isZodPromise(model)) {
        return getKeysFromZodSchema(model.unwrap(), isSelectKey, parentKey);
    }
    else if (isZodDefault(model) || isZodReadonly(model)) {
        return getKeysFromZodSchema(model._def.innerType, isSelectKey, parentKey);
    }
    else if (isZodEffects(model)) {
        return getKeysFromZodSchema(model._def.schema, isSelectKey, parentKey);
    }
    if (parentKey) {
        return isSelectKey ? true : parentKey;
    }
    return {};
};
export const convertExtractedZodKeysToSelectKeys = (keys) => {
    const selections = {};
    for (const [key, value] of Object.entries(keys)) {
        if (typeof value === "boolean") {
            selections[key] = value;
        }
        else {
            selections[key] = {
                select: convertExtractedZodKeysToSelectKeys(value),
            };
        }
    }
    return selections;
};
export const parseZodSchema = (model) => {
    return {
        keys: getKeysFromZodSchema(model, false),
        get prismaKeys() {
            console.warn("prismaKeys is deprecated, please use selectKeys instead");
            return convertExtractedZodKeysToSelectKeys(getKeysFromZodSchema(model, true));
        },
        selectKeys: convertExtractedZodKeysToSelectKeys(getKeysFromZodSchema(model, true)),
        model,
    };
};
//# sourceMappingURL=zod-parser.js.map